/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { FC } from 'react';
import { Pressable, ScrollView, Text, View } from 'react-native';

import { GiftInfoProps } from './type';
import MyImage from './image.png';
import { TwImage } from '@tw/tw-components-rn';
import { styles } from './styles';
import { useBfPageStore } from '@tw/tw-runtime-react';

export function InfoContainer(props: GiftInfoProps) {
  return (
    <View style={styles.container}>
      <View style={styles.banner}>
        <Pressable onPress={()=>{
          console.log('wx.previewImage',wx.previewImage,props.image)
          wx.previewImage({
              current:props.image,
              urls: [props.image]
          })
        }}>
          <TwImage style={styles.image} source={{ uri: props.image }} resizeMode={'contain'}/>
        </Pressable>
      </View>
      <View style={styles.content}>
        <ScrollView>{props.children}</ScrollView>
      </View>
      <View style={styles.footer}>{props.footer}</View>
    </View>
  );
}
